// Prototypes
/*
* Popups
* - showPopup
* - hidePopup
*/
$.fn.extend({
  showPopup: function(force) {
    var $popup = $(this);
    var popupEnable = true,
      showDelay = $popup.data('show-delay'),
      showAgainDelay = $popup.data('show-again-delay'),
      homepageLimit = $popup.data('homepage-limit'),
      visitorLimit = $popup.data('visitor-limit'),
      isVisitor = $popup.data('visitor'),
      showFor = $popup.data('show-for'),
      type = $popup.data('type'),
      id = $popup.data('id');

    // Disable popup if "only enable for visitor" and customer
    if (visitorLimit == true && isVisitor == false) {
      popupEnable = false;
    }

    // Check to see if the cookie exists
    var cookieName = 'popup-' + id;
    var cookieValue = Cookies.get(cookieName);
    if (typeof cookieValue !== 'undefined' && cookieValue == 'true') {
      popupEnable = false;
    }

    // Check for homepage limit
    if (homepageLimit && !cache.$body.hasClass('template-index')) {
      popupEnable = false;
    }

    if (window.self !== window.top && type == 'popup') {
      popupEnable = false;
    }

    // Always show signup-bar popup if inside the editor
    if (force) {
      popupEnable = true;
    }

    if (popupEnable) {
      if (type == 'popup') {
        $.magnificPopup.open({
          items: {
            src: $popup,
            type: 'inline',
            showCloseBtn: false,
          },
          mainClass: 'mfp-slideup',
          removalDelay: 300,
          callbacks: {
            close: function() {
              Cookies.set(cookieName, 'true', { expires: showAgainDelay });
            },
          },
        });
      }

      var $close = $popup.find('.icon-text');
      $close.on('click', function(e) {
        $popup.hidePopup();
        e.preventDefault();
      });

      // On click subscribe button
      var $form = $popup.find('form');
      $form.on('submit', function(e) {
        if (e.target.checkValidity()) {
          if (!$popup.hasClass('Modal--klaviyo-form')) {
            $popup.hidePopup();
          }
          // $(this).submit();
        } else {
          return false;
        }
      });
    }
  },
  hidePopup: function() {
    var $popup = $(this);
    var type = $popup.data('type'),
      id = $popup.data('id');

    if (type == 'popup') {
      $.magnificPopup.close();
    }
  },
  promoSlideUp: function() {
    $(this).slideUp({
      duration: config.slideSpeed,
      progress: StyleHatch.refreshFixTo,
      complete: StyleHatch.refreshFixTo,
    });
  },
  promoSlideDown: function() {
    $(this).slideDown({
      duration: config.slideSpeed,
      progress: StyleHatch.refreshFixTo,
      complete: StyleHatch.refreshFixTo,
    });
  },
  // Simulated versions for the customize theme menu
  showMockPopup: function() {
    var $promos = $('#shopify-section-promos');
    if (!$('.mock-popup-container').length) {
      $promos
        .find('>*:first')
        .append('<div class="mock-popup-container"></div>');
    }
    var $mockPopupContainer = $('.mock-popup-container');
    var $popup = $(this);
    $popup.appendTo($mockPopupContainer);

    $mockPopupContainer.show();
    $popup.show();
  },
  hideMockPopup: function() {
    var $mockPopupContainer = $('.mock-popup-container');
    var $popup = $(this);
    $mockPopupContainer.hide();
    $popup.hide();
  },
});

$(document).ready(function() {
  var $modal = $('.Modal--klaviyo-form');
  $modal.showPopup();
})